import { Card, CardContent, CardMedia, Typography } from "@mui/material";
import { CategoryCardProps } from "../models";

function DescripCategoryCard({
  id,
  bgImg,
  title,
  description,
  handleClick,
}: CategoryCardProps) {
  return (
    <Card
      elevation={1}
      key={id}
      sx={{
        width: "100%",
        transition: "transform 0.3s ease-in-out",
        "&:hover": {
          // transform: "scale(1.05)",
          filter: "opacity(80%)",
          cursor: "pointer",
        },
      }}
      onClick={() => {
        if (handleClick) {
          handleClick(id);
        }
      }}
    >
      <CardMedia
        sx={{ height: 140 }}
        image={bgImg ?? "/images/kodawari_index_4.png"}
      />
      <CardContent>
        <Typography gutterBottom variant="h6" fontWeight="bold" component="div">
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      </CardContent>
    </Card>
  );
}

export default DescripCategoryCard;
